module.exports = __webpack_public_path__ + "media/images/flags/zh-ddd0a631783846caa7da186556305a79.svg";